var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"file-viewer h-inherit",class:{ flex: !_vm.isImg }},[(!_vm.isImg)?_c('iframe',{staticClass:"flex-grow",attrs:{"frameborder":"0","allowfullscreen":"","width":"100%","src":_vm.link}}):_c('img',{attrs:{"src":_vm.link}})])
}
var staticRenderFns = []

export { render, staticRenderFns }